import React from 'react';

import './button.styles.scss';

const Button = ({onClick,children,className}) => (
  <button className={`${className === undefined ? 'buttonBaglantiEkle' : className}`} onClick={onClick} >{children}</button>
);

export default Button;